import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { PlatformAdminGuard } from '../guards/platform-admin.guard';
import { SurveyBuilderDesktopOnlyGuard } from '../guards/survey-builder-desktop-only.guard';
import { lazyRouteNamed } from '../lazy-route';

export const adminRoutes: RouteObject[] = [
  {
    path: '/admin',
    element: <PlatformAdminGuard />,
    children: [
      {
        path: RoutesList.ADMIN_DASHBOARD,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/admin-dashboard-page'),
              'AdminDashboardPage',
            ),
          },
        ],
      },

      {
        path: RoutesList.ADMIN_PLAN_MODULES,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/plan-modules-page'),
              'PlanModulesPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_PLAN_SEAT_LIMITS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/plan-seat-limits-page'),
              'PlanSeatLimitsPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_TRIAL_CONFIG,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/trial-config-page'),
              'TrialConfigPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_TENANTS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/admin-tenants-page'),
              'AdminTenantsPage',
            ),
          },
          {
            path: ':id',
            ...lazyRouteNamed(
              () => import('../../pages/admin/admin-tenant-detail-page'),
              'AdminTenantDetailPage',
            ),
          },
          {
            path: ':id/partner',
            ...lazyRouteNamed(
              () => import('../../pages/admin/admin-tenant-partner-config-page'),
              'AdminTenantPartnerConfigPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_USERS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(() => import('../../pages/admin/admin-users-page'), 'AdminUsersPage'),
          },
          {
            path: ':id',
            ...lazyRouteNamed(
              () => import('../../pages/admin/admin-user-detail-page'),
              'AdminUserDetailPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_DOCUMENT_TYPES,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/admin-document-types-page'),
              'AdminDocumentTypesPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_DISCOUNT_CODES,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/admin-discount-codes-page.component'),
              'AdminDiscountCodesPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_INVITES,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/admin-invites-page'),
              'AdminInvitesPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_SIGNUP_LINKS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/signup-links-page'),
              'SignupLinksPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_EMAIL_TEMPLATES,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/email-templates/email-templates-page'),
              'EmailTemplatesPage',
            ),
          },
          {
            path: ':key',
            ...lazyRouteNamed(
              () => import('../../pages/admin/email-templates/email-template-editor-page'),
              'EmailTemplateEditorPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_QR_GENERATOR,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/admin-qr-generator-page'),
              'AdminQrGeneratorPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_REGULATORY_NEWS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/regulatory-news/admin-page'),
              'AdminRegulatoryNewsPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_SURVEYS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/surveys/admin-surveys-page'),
              'AdminSurveysPage',
            ),
          },
          {
            path: ':id',
            element: <SurveyBuilderDesktopOnlyGuard />,
            children: [
              {
                index: true,
                ...lazyRouteNamed(
                  () => import('../../pages/admin/surveys/admin-survey-builder-page'),
                  'AdminSurveyBuilderPage',
                ),
              },
            ],
          },
        ],
      },
      {
        path: RoutesList.ADMIN_LABEL_RULE_PACKS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/label-rule-packs/admin-label-rule-packs-page'),
              'AdminLabelRulePacksPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_E_INVOICES,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/e-invoices/admin-e-invoices-page'),
              'AdminEInvoicesPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_WHATSAPP,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/admin-whatsapp-page'),
              'AdminWhatsAppPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_IOT_PROVISIONING,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/admin-iot-provisioning-page'),
              'AdminIotProvisioningPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_IOT_CONFIG,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/iot-config-page'),
              'AdminIotConfigPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_INGREDIENTS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/ingredients/admin-ingredients-page'),
              'AdminIngredientsPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_PARTNERS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/partners/admin-partners-page'),
              'AdminPartnersPage',
            ),
          },
        ],
      },
      {
        path: RoutesList.ADMIN_INSIGHTS,
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/admin/insights/admin-insights-page'),
              'AdminInsightsPage',
            ),
          },
        ],
      },
    ],
  },
];
